import React from 'react';
import clsx from 'clsx';
import { Skeleton as UISkeleton } from '@npm-registry/eapteka-ui';
import styles from '../Product.scss';

export const ProductSkeleton = () => {
  return (
    <div className={clsx([styles.root, styles.isSkeleton])}>
      <div className={styles.left}>
        <UISkeleton
          className={clsx([
            styles.skeleton,
            styles.isImage
          ])}
        />
      </div>
      <div className={styles.details}>
        <UISkeleton className={styles.skeleton} />
        <UISkeleton className={styles.skeleton} />
        <UISkeleton
          className={styles.skeleton}
          style={{ maxWidth: '5em' }}
        />
        <UISkeleton
          className={clsx([
            styles.skeleton,
            styles.hideOnMobile
          ])}
          style={{ maxWidth: '11.25em' }}
        />
      </div>
      <div className={styles.controlsWrapper}>
        <span className={styles.price}>
          <UISkeleton className={styles.skeleton} />
          <UISkeleton
            className={clsx([
              styles.skeleton,
              styles.hideOnMobile
            ])}
          />
          <UISkeleton
            className={clsx([
              styles.skeleton,
              styles.hideOnMobile
            ])}
          />
        </span>
        <div className={styles.controls}>
          <UISkeleton
            className={clsx([
              styles.skeleton,
              styles.isButton
            ])}
          />

          <div className={styles.actions}>
            <UISkeleton className={styles.skeleton} />
            <UISkeleton className={styles.skeleton} />
          </div>
        </div>
      </div>
    </div>
  );
};
